import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/BodyText';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => BodyTextMedium,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly);

export default metaOverrideSet;
